export default __webpack_public_path__ + "static/media/explore-mobile-6.26ff3c70.png";